import { ClientEvent } from '@udemy/event-tracking';

/**
 This event is fired when a user clicks on any UFB notice link on a marketplace page
 */
export class UFBNoticeClickEvent extends ClientEvent {
  constructor({
    locale,
    placement
  }) {
    super('UFBNoticeClickEvent');
    this.locale = void 0;
    this.placement = void 0;
    this.locale = locale;
    this.placement = placement;
  }
  get eventLocale() {
    return this.locale;
  }
  get eventPlacement() {
    return this.placement;
  }
}

/**
 This event is fired when a user sees any UFB notice link on a marketplace page
 **/
export class UFBNoticeImpressionEvent extends ClientEvent {
  constructor({
    locale,
    placement,
    url = null
  }) {
    super('UFBNoticeImpressionEvent');
    this.locale = void 0;
    this.placement = void 0;
    this.url = void 0;
    this.locale = locale;
    this.placement = placement;
    this.url = url;
  }
  get eventLocale() {
    return this.locale;
  }
  get eventPlacement() {
    return this.placement;
  }
}
//# sourceMappingURL=events.js.map